import { Controller } from "@hotwired/stimulus"

// Désactive le bouton dès le premier clic pour éviter le double-clic le
// plus courant (confort — la vraie protection anti double-commande est
// côté serveur via la clé d'idempotence, ce contrôleur n'est qu'un
// renfort pour ne pas même laisser partir une deuxième requête facile).
export default class extends Controller {
  connect() {
    const form = this.element.closest("form")
    if (!form) return

    form.addEventListener("submit", () => {
      if (this.element.disabled) return
      this.element.disabled = true
      this.element.dataset.originalHtml = this.element.innerHTML
      this.element.innerHTML = "Envoi en cours…"
    })
  }
}
